import cropMarkDeclareReducer from "./markDeclareReducer";

const cropMarkDeclareReducers = {
    cropMarkDeclare: cropMarkDeclareReducer
}

export default cropMarkDeclareReducers